module.exports = {"623026100":"郎木寺镇","623026101":"玛艾镇","623026200":"尕海乡","623026201":"西仓乡","623026202":"拉仁关乡","623026203":"双岔乡","623026204":"阿拉乡","623026402":"双岔林场","623026403":"李恰如种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623026.json
// module id = 2764
// module chunks = 0